import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import DropDown from "../../../../Filters/DropDown";
import { Input } from "../../../../Input/Input";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import {
  sunsetDetailDataState,
  VerticalTableLabel,
  VerticalTableRow,
  VerticalTableValue,
} from "./SunsetSubs";

export default function SunsetParty() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );

  const [sunsetPartyList, setSunsetPartyList] = useState({
    // 적용 대상 파티
    value: location?.state
      ? location?.state?.sunsetData?.ssetParty?.length > 0
        ? "input"
        : location?.state?.sunsetData?.ssetParty?.length === 0
        ? "all"
        : ""
      : "",
    label: location?.state
      ? location?.state?.sunsetData?.ssetParty?.length > 0
        ? "직접 입력"
        : location?.state?.sunsetData?.ssetParty?.length === 0
        ? "전체"
        : "선택"
      : "선택",
  });
  const [sunsetPid, setSunsetPid] = useState(
    // pid 직접 입력
    location?.state?.sunsetData?.ssetParty?.length > 0
      ? location?.state?.sunsetData?.ssetParty.toString()
      : ""
  );

  // 적용 대상 파티 리스트
  const sunsetPartyOption = [
    { value: "all", label: "전체" },
    { value: "input", label: "직접 입력" },
  ];

  useEffect(() => {
    if (sunsetPartyList?.value !== "" || sunsetPid !== "") {
      setSunsetDetailData({
        ...sunsetDetailData,
        sunsetParty: sunsetPartyList?.value === "all" ? "0" : sunsetPid,
      });
    }
  }, [sunsetPartyList, sunsetPid]);

  return (
    <>
      {/* 적용 대상 파티 */}
      <VerticalTableRow>
        <VerticalTableLabel>적용 대상 파티</VerticalTableLabel>

        {buttonType === "view" ? (
          <VerticalTableValue>{sunsetPartyList?.label}</VerticalTableValue>
        ) : (
          <DropDown
            optionList={sunsetPartyOption}
            dropdownValue={sunsetPartyList}
            setDropDownValue={setSunsetPartyList}
          />
        )}
      </VerticalTableRow>

      {/* PID 입력 */}
      <VerticalTableRow>
        <VerticalTableLabel>PID 입력</VerticalTableLabel>
        <Input
          placeholder="직접 입력"
          style={{ width: 220 }}
          disabled={
            sunsetPartyList?.value === "all" ||
            buttonType === "view" ||
            sunsetPartyList?.value === ""
          }
          value={sunsetPid}
          onChange={(e) => setSunsetPid(e.target.value)}
        />
      </VerticalTableRow>
    </>
  );
}
